import create from 'zustand';
import { persist } from 'zustand/middleware';

type UserStoreType = {
  user?: User
  accessCode?: string
  token?: string
  setUser: (_user: User) =>void,
  setToken: (_token: string) => void
  setAccessCode: (_accessCode: string) => void
  set: (_data: {user?: User, token?: string, accessCode?: string}) => void
  setLogout: () => void
}

const useUser = create<UserStoreType>(persist(
  (set) => ({
    user: null,
    token: null,
    accessCode: null,
    setUser: (user: User) => set({ user }),
    setToken: (token: string) => set({ token }),
    setAccessCode: (accessCode: string) => set({ accessCode }),
    set,
    setLogout: () => set({
      user: null,
      token: null,
      accessCode: null,
    }),
  }),
  { name: 'auth', whitelist: ['token', 'accessCode'] },
));
export default useUser;
